<template>
  <div class="home">
    <JumbotronComp/>
    <!--<AlertsComp msg="Welcome to Your Vue.js App" />-->
    <div class="container">
      <section class="h-100"><AnimateComp/></section>
      <section class="h-100"><FaderComp/></section>
      <section class="row h-100"><CardsComp/></section>
    </div>
    
    <PostsComp/>
  </div>
</template>

<script>

import JumbotronComp from "@/components/JumbotronComp.vue";
//import AlertsComp from "@/components/AlertsComp.vue";
import FaderComp from "@/components/FaderComp.vue";
import CardsComp from "@/components/CardsComp.vue";
import PlaceholderTxtComp from "@/components/PlaceholderTxtComp.vue";
import AnimateComp from "@/components/AnimateComp.vue"
import PostsComp from "@/components/PostsComp.vue"


export default {
  name: "home",
  components: {
    JumbotronComp,
    AnimateComp,
    //AlertsComp,
    FaderComp,
    CardsComp,
    PostsComp

  }
};
</script>
